<template>
  <div class="garyaBg">
    <!-- section one -->
    <section class="w-full flexmobile mx-auto md:px-20 md:mt-80 px-4">
      <h1 class="text-white font-semibold pt-10 md:pt-20 text-2xl md:text-4xl">In a nutshell</h1>
      <div class="flex mt-8 ml-8 flexmobile flex-col md:flex-row justify-between">
        
        <div class="w-full md:mr-5">
          <section class="flex flex-col rounded-none">
            
            <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6 text-rose-300">Shortcomings of the Website</p>
            <ul class="mt-5 text-lg text-white">
              <li class="pt-6">Clunky Navigation</li>
              <li class="pt-6">Repeated Content on multiple pages</li>
              <li class="pt-6">Difficulty in reaching target audience</li>
              <li class="pt-6">Old School website design</li>
              <li class="pt-6">Lengthy process to get in touch with partnered hospitals</li>
              <li class="pt-6">Website lacked to show the NGO's Story and journey</li>
              <li class="pt-6">Lack of trust due to the website's inconsistencies</li>
            </ul>
          </section>
        </div>
        <div class="h-full hidden md:block">
          <img loading="lazy" class="h-full" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726661173/Line_2_cwj1zm.png" alt="">
        </div>
        <div class="w-full md:ml-20 mt-10 md:mt-0">
          <section class="flexmobile flex-row rounded-none">
            <div>
              <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6 text-rose-300">How did the Redesign help?</p>
              <ul class=" text-lg text-white">
                <li class="pt-8 text-lg ">Redesigned the Information Architecture</li>
                <li class="pt-6 text-lg ">Eliminated the redundant content</li>
                <li class="pt-6 text-lg ">Curated posts for Social media platforms for engagement</li>
                <li class="pt-6 text-lg ">Changed the Style guide for a visual revamp</li>
                <li class="pt-6 text-lg ">Added the "Our Partners" page dedicated to partnered hospitals and added contact information</li>
                <li class="pt-6 text-lg ">Added a section called "Our Story" to promote NGO's vision and mission</li>
                <li class="pt-6 text-lg ">Added testimonials of current volunteers</li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </section>
    <!-- section 2 -->
    <section ref="animatedSection" class="container justify-center flex mx-auto px-4 md:mt-64">
      <div>
        <img loading="lazy" :class="{'animate__animated animate__zoomInRight': isVisible}" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726661229/iii_ur1pvy.png" alt="">
      </div>
    </section>
    <!-- section 3 -->
    <section class=" flex flex-col md:mt-64  mx-auto ml-16 ">
      <section class=" flexmobile  px-4  rounded-none">
      <h1 class="self-start text-4xl font-semibold text-white">Objectives & Outcomes</h1>
      <p class="text-rose-300 text-2xl md:text-3xl font-semibold pt-6 md:pt-16 ml-12">Website Redesign with major focus on Information Architecture</p>
      <ul class="pt-6 text-lg md:pb-6 text-white ml-12">
        <li class="pt-6 text-lg ">Organize Content Logically to aid navigation</li>
        <li class="pt-6 text-lg ">Improve User Flow</li>
        <li class="pt-6 text-lg ">Streamline Interactions to reduce confusion</li>
        <li class="pt-6 text-lg ">Ensure Efficient Information Retrieval</li>
      </ul>
    </section>
    </section>

    <!-- section 4 -->
    <section class="container mx-auto px-4 mt-16 flexmobile">
      <div>
        <p class="dancing-script text-rose-300 text-2xl md:text-3xl font-semibold pt-6">Old Site map :</p>
      </div>
      <div class=" flex justify-center items-center">
        <div>
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662303/WarriorWagons_2_mofhha.png" alt="">
      </div>
      </div>
    </section>

    <!-- section 5 -->
    <section class="container mx-auto px-4 mt-32 flexmobile">
      <div>
        <p class="dancing-script text-rose-300 text-2xl md:text-3xl font-semibold pt-6">New Site Map:</p>
      </div>
      <div>
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662313/Sitemap_1_cw1xoh.png" alt="">
      </div>
    </section>

    <!-- section 6  -->
    <section class="flex flexmobile md:mx-auto px-4 mt-12  flex-col rounded-none">
      <p class="text-rose-300 text-2xl md:text-3xl font-semibold pt-6 md:pt-16 ml-16">Marketing</p>
      <p class="dancing-script text-white text-2xl md:text-3xl font-semibold pt-6 md:pt-16 ml-16">Offline Marketing via Newsletters</p>
      <p class="pt-8 text-lg  text-white ml-16">Visually revamped the quarterly newsletters to reinforce the brand's essence in order to demonstrate loyalty and provide in-depth information.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'WangosProjectTwo',
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
          }
        });
      },
      {
        threshold: 0.1, // Adjust this threshold as needed
      }
    );

    observer.observe(this.$refs.animatedSection);
  },
}
</script>
